module.exports = __webpack_public_path__ + "static/media/action.728cefdf.svg";